import { Amplify } from 'aws-amplify'

// derive the settings for the oauth part of Auth configuration
function oauth(clientSubdomain, amplifyConfigs, altClientName) {
  // subdomains using the User ID are not used in development
  const subDomain = amplifyConfigs.development === 'true' ? '' : clientSubdomain
  const usedSubDomain = altClientName ? altClientName : subDomain
  const usedUrl =
    altClientName && subDomain
      ? amplifyConfigs.url.replace(subDomain, altClientName)
      : amplifyConfigs.url
  const redirectUrl = `https://${usedSubDomain}${usedUrl}`
  return {
    domain: amplifyConfigs[clientSubdomain].hostedUiDomain,
    scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: redirectUrl,
    redirectSignOut: redirectUrl,
    responseType: 'token'
  }
}

const libraryOptions = {
  Storage: {
    S3: {
      prefixResolver: async ({ accessLevel, targetIdentityId }) => {
        if (accessLevel === 'guest') {
          return 'uploads/'
        } else if (accessLevel === 'initialAccess') {
          return ''
        } else if (accessLevel === 'protected') {
          return `protected/${targetIdentityId}/`
        } else {
          return `private/${targetIdentityId}/`
        }
      }
    }
  }
}

// configure AWS amplify for both cognito authentication (Auth) and S3 usage (Storage)
export function configureAmplify(
  clientSubdomain,
  amplifyConfigs,
  altClientName
) {
  Amplify.configure(
    {
      Auth: {
        Cognito: {
          identityPoolId: amplifyConfigs[clientSubdomain].identityPoolId,
          region: amplifyConfigs[clientSubdomain].region,
          userPoolId: amplifyConfigs[clientSubdomain].userPoolId,
          userPoolClientId: amplifyConfigs[clientSubdomain].userPoolWebClientId,
          signUpVerificationMethod: 'code',
          loginWith: {
            oauth: oauth(clientSubdomain, amplifyConfigs, altClientName)
          }
        }
      },
      Storage: {
        S3: {
          bucket: amplifyConfigs[clientSubdomain].bucketName,
          region: amplifyConfigs[clientSubdomain].region
        }
      }
    },
    libraryOptions
  )
}
